import { type FC, useMemo } from 'react';
import { styled } from 'styled-components';

import { QueryState } from '@/api/components/QueryState';
import { NewsArticle } from '@/api/newsArticles/models/newsArticlesModels';
import { useFetchNewsArticlesQuery } from '@/api/newsArticles/newsArticlesApi';
import { isNotReady } from '@/api/utils/isNotReady';

import { CardColumn, Row } from '../Grid';
import { NewsArticleCardSmall } from './NewsArticleCardSmall';

interface Props {
  limit?: number;
}

export const NewsArticles: FC<Props> = ({ limit }) => {
  const newsArticlesQuery = useFetchNewsArticlesQuery();

  const articlesToDisplay = useMemo<NewsArticle[]>(() => {
    if (!newsArticlesQuery.data) {
      return [];
    }

    if (limit) {
      return newsArticlesQuery.data.slice(0, limit);
    }

    return newsArticlesQuery.data;
  }, [newsArticlesQuery.data, limit]);

  return (
    <>
      {isNotReady(newsArticlesQuery) ? (
        <QueryState query={newsArticlesQuery} />
      ) : (
        <Row id="news-articles-grid">
          {articlesToDisplay.map((newsArticle) => (
            <StyledCardColumn $span={4} key={newsArticle.link}>
              <NewsArticleCardSmall newsArticle={newsArticle} />
            </StyledCardColumn>
          ))}
        </Row>
      )}
    </>
  );
};

const StyledCardColumn = styled(CardColumn)`
  display: flex;
`;
